module.exports = __webpack_public_path__ + "static/adrian-37316ad80343b035831d0d3d009a23da.jpg";